<div class="transfer-container" *ngIf="activeView === 'selection'">
    <div class="modal-wrapper">
        <!-- Header -->
        <div class="modal-header">
            <h2>Transfer Funds</h2>
            <div class="close-btn" (click)="closeModal()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </div>
        </div>

        <!-- Content -->
        <div class="modal-content">
            <!-- Top Row -->
            <div class="card-row">
                <div class="card large" (click)="openView('send-upi')">
                    <div class="icon-wrapper">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                            <path d="M12 19V5M12 5L5 12M12 5L19 12" stroke="url(#icon-grad)" stroke-width="2.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="card-label">Send UPI</div>
                </div>
                <div class="card small" (click)="openView('receive')">
                    <div class="icon-wrapper">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                            <path d="M12 5V19M12 19L5 12M12 19L19 12" stroke="url(#icon-grad)" stroke-width="2.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="card-label">Receive</div>
                </div>
            </div>

            <!-- Bottom Row -->
            <div class="card-row">
                <div class="card small" (click)="openView('bank')">
                    <div class="icon-wrapper">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0124 6.12226 19.0231 7.02061C19.0338 7.91896 18.7544 8.79904 18.2247 9.5307C17.695 10.2624 16.9429 10.8045 16.07 11.08M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7Z"
                                stroke="url(#icon-grad)" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="card-label">To Bank Account</div>
                </div>
                <div class="card small" (click)="openView('own')">
                    <div class="icon-wrapper">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                            <path d="M16 3H21V8M4 21L21 4M21 21V16H16" stroke="url(#icon-grad)" stroke-width="2.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="card-label">To Own Account</div>
                </div>
                <div class="card small" (click)="openView('scan')">
                    <div class="icon-wrapper">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M3 7V5C3 3.89543 3.89543 3 5 3H7M17 3H19C20.1046 3 21 3.89543 21 5V7M21 17V19C21 20.1046 20.1046 21 19 21H17M7 21H5C3.89543 21 3 20.1046 3 19V17M7 12H17"
                                stroke="url(#icon-grad)" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="card-label">Scan QR Code</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Shared SVG Definitions -->
    <svg style="width:0;height:0;position:absolute;" aria-hidden="true" focusable="false">
        <linearGradient id="icon-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color:#E7733A;stop-opacity:1" />
            <stop offset="100%" style="stop-color:#ECB53E;stop-opacity:1" />
        </linearGradient>
    </svg>
</div>

<!-- Modal Components -->
<app-send-upi-modal *ngIf="activeView === 'send-upi'" (close)="closeModal()"></app-send-upi-modal>
<app-scan-qr-modal *ngIf="activeView === 'receive' || activeView === 'scan'" (close)="closeModal()"></app-scan-qr-modal>
<app-bank-account-modal *ngIf="activeView === 'bank'" (close)="closeModal()"></app-bank-account-modal>
<app-own-account-modal *ngIf="activeView === 'own'" (close)="closeModal()"></app-own-account-modal>